import { Grid } from '@mui/material'
import { ICommonProduct, MCommonProduct } from '@Models/common.model'
import Product from '@Components/Product/Product'

// model section
interface IFirearms {
    data: MCommonProduct[]
    firearmActions: any
}

function Firearms(props: IFirearms) {
    // core section
    const { data, firearmActions } = props

    // main
    return (
        <>
            {data?.length ? (
                data?.map((item: ICommonProduct, index: number) => (
                    <Grid
                        item
                        md={6}
                        sm={12}
                        key={`${item?.serialCode}_gun_list_item${+index}`}
                    >
                        <Product
                            product={item}
                            balance={false}
                            getActions={firearmActions}
                            // checkbox={false}
                            checkbox={false}
                            checked={item?.checked}
                            productType="inspection"
                        />
                    </Grid>
                ))
            ) : (
                <Grid item md={12}>
                    <div className="text-center mb-4">No data</div>
                </Grid>
            )}
        </>
    )
}

export default Firearms
